import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import AssetType from "../../models/asset-type";

const RECORS_PER_SEARCH = 20;

type AssetTypeSelectProps = {
  value: AssetType | null;
  disabled?: boolean;
  onChange: (_: AssetType | null) => void;
};

const AssetTypeSelect: React.FC<AssetTypeSelectProps> = ({
  value,
  disabled,
  onChange,
}) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (
      | AssetType
      | { options: AssetType[]; label?: string }
    )[]
  ): Promise<
    Response<AssetType, { options: AssetType[]; label?: string }, any>
  > => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("company_id", companyId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<AssetType>(
      "/asset_types/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: AssetType[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Tipo de activo"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: AssetType) => `${option.name}`}
      getOptionValue={(option: AssetType) => `${option.id}`}
      value={value}
      isDisabled={disabled}
      isClearable={true}
    />
  );
};

export default AssetTypeSelect;
